import "../CSS/tantramassagepaar.css";

import TantramassageNavigation
    from "../components/TantramassageNavigation";


function TantramassagePaarPage() {

    return (
        <>

            <TantramassageNavigation />


            <div className="intro">

                <h1>
                    Tantramassage für Paare im Sarganserland
                </h1>

            </div>


            <main className="massage-paar-main">

                <section className="massage-paar-einstieg">

                    <figure className="massage-paar-bild">

                        <img
                            src="/Fotos/massage_paar.png"
                            alt="Tantramassage für Paare im Sarganserland"
                        />

                        <figcaption>
                            Gemeinsame Zeit, Achtsamkeit und bewusste Nähe
                        </figcaption>

                    </figure>


                    <div className="massage-paar-text">

                        <p>
                            Meine Tantramassage für Paare im Sarganserland
                            bietet Euch die Möglichkeit, gemeinsam eine
                            besondere Form von Achtsamkeit, Berührung und
                            bewusster Nähe zu erleben. Das Angebot richtet
                            sich auch an Paare aus Mels, Sargans,
                            Bad Ragaz und der umliegenden Region.
                        </p>


                        <p>
                            Im Mittelpunkt steht Eure gemeinsame Erfahrung.
                            Ihr dürft Euch Zeit nehmen, zur Ruhe kommen
                            und Euch selbst und einander bewusst wahrnehmen.
                        </p>


                        <p>
                            Dabei geht es nicht um Leistung oder darum,
                            etwas Bestimmtes erreichen zu müssen.
                            Vielmehr entsteht ein Raum, in dem Vertrauen,
                            Nähe und achtsame Berührung erlebt werden dürfen.
                        </p>


                        <p>
                            Eure persönlichen Wünsche und Grenzen werden
                            vor der Massage gemeinsam besprochen und während
                            der gesamten Begegnung respektiert.
                        </p>

                    </div>

                </section>


                <section className="massage-paar-details">

                    <h2>
                        Gemeinsame Erfahrung als Paar
                    </h2>


                    <p>
                        Eine Tantramassage als Paar kann Euch die Möglichkeit
                        geben, Berührung und Nähe einmal ganz bewusst und
                        ohne den gewohnten Alltag zu erleben.
                    </p>


                    <p>
                        Ihr könnt Euch dabei auf unterschiedliche Weise
                        begegnen und neue Wahrnehmungen von Nähe,
                        Entspannung und Verbundenheit entdecken.
                    </p>


                    <p>
                        Wie die gemeinsame Tantramassage gestaltet wird,
                        besprechen wir vorher miteinander. Dabei ist mir
                        wichtig, dass sich beide Personen mit dem vereinbarten
                        Rahmen wohlfühlen.
                    </p>

                </section>

            </main>

        </>
    );
}


export default TantramassagePaarPage;